import {Component, NgZone, OnInit} from '@angular/core';
import {MapService} from '../../core/map/map.service';
import {NewAccountComponent} from '../shared/new-account/new-account.component';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {AccountsService} from '../../core/accounts/accounts.service';
import {RoutesService} from '../../core/routes/routes.service';
import {PlacesService} from '../../core/places/places.service';
import {AuthService} from '../../core/auth/auth.service';

@Component({
  selector: 'app-info-panel',
  templateUrl: './info-panel.component.html',
  styleUrls: ['./info-panel.component.scss']
})
export class InfoPanelComponent implements OnInit {

  account: any;
  accountDetails: any;
  place: any;
  placeDetails: any;

  bsModalRef: BsModalRef;

  constructor(private zone: NgZone,
              private modalService: BsModalService,
              private authService: AuthService,
              private mapService: MapService,
              private routesService: RoutesService,
              private placesService: PlacesService,
              private accountsService: AccountsService) { }

  ngOnInit() {
    this.mapService.selectPlace.subscribe(place => {
      if (place) {
        this.place = place;
        this.placeDetails = null;
        this.account = null;
        this.accountDetails = null;
      } else {
        this.place = null;
      }
    });

    this.mapService.selectAccount.subscribe(account => {
      if (account) {
        this.place = null;
        this.placeDetails = null;
        this.account = account;
        this.accountDetails = null;
      } else {
        this.account = null;
      }
    });

    this.placesService.selectPlace.subscribe(placeId => {
      if (placeId) {
        this.place = null;
        this.account = null;
        this.accountDetails = null;
        this.openPlaceDetails(placeId);
      } else {
        this.placeDetails = null;
      }
    });

    this.accountsService.selectAccount.subscribe(account => {
      if (account) {
        this.place = null;
        this.placeDetails = null;
        this.account = null;
        this.openAccountDetails(account);
      } else {
        this.accountDetails = null;
      }
    });

    this.accountsService.deleteAccount.subscribe(id => {
      if (id) {
        if (this.account && this.account._id === id) {
          this.account = null;
        }
      }
    });
  }

  addAccount(placeDetails) {
    this.bsModalRef = this.modalService.show(NewAccountComponent, { initialState: { place: placeDetails }});
  }

  addPlaceToRoute(place) {
    this.routesService.addPlaceToRoute(place);
  }

  addAccountToRoute(account) {
    this.routesService.addAccountToRoute(account);
  }

  getDetailsAndAddAccount(place) {
    this.mapService.placesSearchService.getDetails({placeId: place.place_id}, (placeDetails, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        this.zone.run(() => {
          this.addAccount(placeDetails);
        });
      }
    });
  }

  openPlaceDetails(placeId: string) {
    this.mapService.placesSearchService.getDetails({placeId}, (placeDetails, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        this.zone.run(() => {
          this.placeDetails = placeDetails;
        });
      }
    });
  }

  openAccountDetails(account: any) {
    this.accountsService.get(account._id)
      .subscribe((accountDetails: any) => {
        this.accountDetails = accountDetails;
      });
  }

  locatePlace(placeDetails) {
    this.mapService.center(placeDetails.geometry.location.lat(), placeDetails.geometry.location.lng());
  }

  isPlaceInRoute(place) {
    return this.routesService.isPlaceInRoute(place);
  }

  isAccountInRoute(account) {
    return this.routesService.isAccountInRoute(account);
  }

  navigateToPlace(place) {
    window.open(`https://www.google.com/maps?daddr=${place.geometry.location.lat()},${place.geometry.location.lng()}`, '_blank');
  }

  navigateToAccount(account) {
    window.open(`https://www.google.com/maps?daddr=${account.coords[1]},${account.coords[0]}`, '_blank');
  }

}



// WEBPACK FOOTER //
// ./client/app/components/info-panel/info-panel.component.ts